import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useApp } from '../context/AppContext';
import StarField from '../components/StarField';
import { GalaxyMark, OrbitWordmark } from '../components/OrbitLogo';
import PhoneFrame from '../components/PhoneFrame';
import { toast } from 'sonner';

// Email + password login. Autoconfirm is on server-side so a matching
// account is always immediately usable -- no email verification step.
export default function Login() {
  const nav = useNavigate();
  const { login } = useApp();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [status, setStatus] = useState('idle'); // idle | sending

  const submit = async (e) => {
    e.preventDefault();
    if (status === 'sending') return;
    if (!email.trim() || !password) { toast('Enter your email and password'); return; }

    setStatus('sending');
    try {
      await login(email.trim(), password);
      nav('/home', { replace: true });
    } catch (err) {
      setStatus('idle');
      toast(err.message || 'Could not sign in');
    }
  };

  const fieldStyle = { background: 'var(--lavender-input)', color: '#2a2540' };

  return (
    <PhoneFrame>
      <div className="relative min-h-full flex flex-col">
        <StarField gold={false} />
        <div className="relative z-10 flex-1 flex flex-col items-center px-8">
          <div className="floaty mt-16 mb-3"><GalaxyMark size={118} /></div>
          <div className="mb-10"><OrbitWordmark size={46} /></div>

          <form onSubmit={submit} className="w-full max-w-sm">
            <input
              style={fieldStyle}
              type="email"
              className="orbit-field placeholder:text-[#8a83a8] mb-3"
              placeholder="you@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="email"
              autoFocus
            />
            <input
              style={fieldStyle}
              type="password"
              className="orbit-field placeholder:text-[#8a83a8] mb-4"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
            />
            <div className="relative flex justify-center">
              <span className="absolute -bottom-6 w-40 h-24 rounded-full" style={{ background: 'radial-gradient(circle, rgba(240,180,60,.55), transparent 70%)', filter: 'blur(12px)' }} />
              <button type="submit" disabled={status === 'sending'} className="press relative font-display orbit-primary-button" style={{
                fontSize: 20, padding: '12px 48px', opacity: status === 'sending' ? 0.6 : 1,
              }}>{status === 'sending' ? 'Signing in…' : 'Log in'}</button>
            </div>
            <p className="text-center text-xs mt-4" style={{ color: '#8079a6' }}>
              New here?{' '}
              <Link to="/signup" className="underline" style={{ color: '#cdb8ff' }}>Create an account</Link>
            </p>
          </form>

          <div className="star-line w-full max-w-sm mt-16 mb-8" />
        </div>
      </div>
    </PhoneFrame>
  );
}
